export class UserPreferencesViewModel {
    Language: number;
    Currency: number;
    UnitOfMeasurementName: string;
    Email: string;
    Mobile: string;
    PhoneNumber: string;
    PhoneAreaCode: string;
    Fax: string;
    FaxAreaCode: string;
    Address: string;
    Address2: string;
    Suburb: string;
    PostCode: string;
    State: string;
    Country: string;
    UCShowWornPerToday: number;
    UnitofDistance?: string;
}

export class CurrencyViewModel {
    Id: number;
    Code: string;
    Name: string;
}

export class LanguageViewModel {
    Id: number;
    Name: string;
}

export class Tuple {
    public m_Item1: any;
    public m_Item2: any;
}